import { useSelector } from 'react-redux';
import { ArrowDropDownIcon } from '@mui/x-date-pickers';
import { Box, Typography } from '@mui/material';
import { useThemes } from '../../../../components/Theme/theme';
const HeaderList = ({ setSelectedTab, dat, selectedTab, setAnchorEl, setTableData, setSelectedAccount }) => {
  const { theme } = useThemes();
  let getCompany = useSelector((state) => state?.companyReducer?.companyDetails);
  return (
    <Box
      sx={{
        display: getCompany.relatedcompanydetailsnew[0].registrationtype === 1 && dat.id === 6 ? 'none' : 'flex',
        justifyContent: 'space-evenly',
        color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
      }}
      // onClick={(event) => {
      //   setSelectedTab(dat.id);
      //   setAnchorEl(event.currentTarget);
      // }}
      onClick={(event, newValue) => {
        setSelectedTab((prev) => {
          console.log(prev, 'prev');
          if (prev != dat.id) {
            if (
              (prev !== 1 && prev !== 2 && prev !== 3 && (dat.id == 1 || dat.id == 2 || dat.id == 3)) ||
              ((prev == 1 || prev == 2 || prev == 3) && dat.id != 1 && dat.id != 2 && dat.id && 3)
            ) {
              setSelectedAccount([]);
              setTableData([]);
            }
          }
          return dat.id;
        });
        setAnchorEl(event.currentTarget);
      }}
    >
      <Typography
        variant="h1"
        key={dat.id}
        sx={
          dat.id === selectedTab
            ? {
                textDecoration: 'underline',
                textDecorationColor: theme.palette.primary.main,
                textDecorationThickness: '3px',
                textUnderlineOffset: '10px',
                cursor: 'pointer',
              }
            : {
                cursor: 'pointer',
              }
        }
      >
        {dat.label}
      </Typography>
      {[1, 2, 3, 5, 6, 7, 9].includes(dat.id) ? <ArrowDropDownIcon /> : null}
    </Box>
  );
};
export default HeaderList;
